
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SocialTradingAccountMode enum
 */
class SocialTradingAccountMode {
  /**
   * Initialize enum with a given value
   * @param {SocialTradingAccountMode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof SocialTradingAccountMode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!SocialTradingAccountMode}
   * @param {!SocialTradingAccountMode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingAccountMode)) {
      throw new TypeError('Instance of SocialTradingAccountMode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!SocialTradingAccountMode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!SocialTradingAccountMode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === SocialTradingAccountMode.MAM.value) {
      return 'MAM'
    }
    if (this.value === SocialTradingAccountMode.CT.value) {
      return 'CT'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!SocialTradingAccountMode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!SocialTradingAccountMode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!SocialTradingAccountMode} Created enum
   */
  static fromObject (other) {
    return new SocialTradingAccountMode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
SocialTradingAccountMode.MAM = new SocialTradingAccountMode(0 + 0)
// noinspection PointlessArithmeticExpressionJS
SocialTradingAccountMode.CT = new SocialTradingAccountMode(1 + 0)

export { SocialTradingAccountMode };

/**
 * Fast Binary Encoding SocialTradingAccountMode field model
 */
class FieldModelSocialTradingAccountMode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelSocialTradingAccountMode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelSocialTradingAccountMode}
   * @param {SocialTradingAccountMode=} defaults Default value, defaults is new SocialTradingAccountMode()
   * @returns {!SocialTradingAccountMode} Result value
   */
  get (defaults = new SocialTradingAccountMode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new SocialTradingAccountMode(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelSocialTradingAccountMode}
   * @param {!SocialTradingAccountMode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelSocialTradingAccountMode };
